import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class ConsumerCheckoutHandler {
	url: any;

	constructor(
		public http: Http,
		public globals: Globals,
		public storage: Storage,
		public httpHelper: HttpHelper) {
	
	}

	buyOffer(data){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'payment/whiskey/' + this.globals.whiskeyId;

			this.storage.get('loginData').then((loginData) => {
				this.http.post(
					this.url,
					data,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});		
	}
}



// WEBPACK FOOTER //
// ./src/providers/consumer-checkout-handler.ts